import React, { createContext, useState, useMemo, FC } from 'react'

import { CellContextShape, CellEditorConfig } from './types'

export const CellContext = createContext<CellContextShape>({
  cellEditorConfig: null,
  cellEditorPlugins: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set: () => {},
})

interface ContextValue {
  cellEditorConfig: null | CellEditorConfig
  cellEditorPlugins: null | JSX.Element | Array<JSX.Element>
}

interface Props {
  children?: React.ReactNode
}

export const TableContext: FC<Props> = ({ children }) => {
  const [contextValue, setContextValue] = useState<ContextValue>({
    cellEditorConfig: null,
    cellEditorPlugins: null,
  })

  return (
    <CellContext.Provider
      value={useMemo(
        () => ({
          cellEditorConfig: contextValue.cellEditorConfig,
          cellEditorPlugins: contextValue.cellEditorPlugins,
          set: (cellEditorConfig, cellEditorPlugins) => {
            setContextValue({ cellEditorConfig, cellEditorPlugins })
          },
        }),
        [contextValue.cellEditorConfig, contextValue.cellEditorPlugins]
      )}
    >
      {children}
    </CellContext.Provider>
  )
}
